import { BsUiChecksGrid } from "react-icons/bs";
import { IoMenuOutline } from "react-icons/io5";

const FilterHeader = ({
  title,
  setView = null,
  view = null,
  dropdown = true,
  className = "",
}) => {
  return (
    <div className={`flex justify-between bg-primary ${className}`}>
      <p className="py-4 pl-4 font-pop text-xl font-medium uppercase text-white ">
        {title || "Category Ads"}
      </p>
      <div className="flex items-center gap-2 pr-4 font-pop text-xs font-bold uppercase text-white">
        {view && setView && (
          <>
            <span>View</span>
            <div
              className={`p-2  ${view === "list" ? "bg-white" : "bg-primary"}`}
            >
              <IoMenuOutline
                className={`h-4 w-4 cursor-pointer ${
                  view === "list" ? "text-primary" : "text-white"
                }`}
                onClick={(_) => setView("list")}
              />
            </div>
            <div
              className={`mr-4 p-2 ${
                view === "grid" ? "bg-white" : "bg-primary"
              }`}
            >
              <BsUiChecksGrid
                className={`h-4 w-4 cursor-pointer ${
                  view === "grid" ? "text-primary" : "text-white"
                }`}
                onClick={(_) => setView("grid")}
              />
            </div>
          </>
        )}
        {dropdown && (
          <>
            <span>Sort By:</span>
            <select
              name=""
              id=""
              className="border border-white bg-primary px-2.5 py-1 text-white outline-none outline-2"
            >
              <option className="font-pop text-xs font-medium" value="1">
                Newly Listed
              </option>
              <option className="font-pop text-xs font-medium" value="2">
                Oldest
              </option>
              <option className="font-pop text-xs font-medium" value="3">
                Price Ascending
              </option>
              <option className="font-pop text-xs font-medium" value="4">
                Price Desending
              </option>
            </select>
          </>
        )}
      </div>
    </div>
  );
};

export default FilterHeader;
